<h4>{{ 'Add Recipient' | translate | async }}</h4>

<div>
  <mat-form-field>
    <input matInput placeholder="{{ 'Customer Name' | translate | async }}" [(ngModel)]="customerName">
  </mat-form-field>
</div>

<div>
  <mat-form-field>
    <input matInput placeholder="{{ 'Email Address' | translate | async }}" [(ngModel)]="email">
  </mat-form-field>
</div>


<div class="button-container">
  <button mat-raised-button (click)="onCancelClick()">{{'Cancel' | translate | async}}</button>
  <button mat-raised-button color="warn" (click)="onAddClick()">{{'Add' | translate | async}}</button>
</div>